export enum ConferenceCommitteeMembers {
  EXPERT_DOMAIN = "Expert in domain",
  EXPERT_COMMUNITIES = "Expert in communities",
  EXPERT_PUBLIC_SPEAKING = "Expert in public speaking",
}
